import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/chadcn/Dialog"

type FoodLogInfoModalProps = {
  open: boolean
  onClose: () => void
}

const FoodLogInfoModal = ({ open, onClose }: FoodLogInfoModalProps) => (
  <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
    <DialogContent className="max-w-sm">
      <DialogHeader>
        <DialogTitle className="sr-only">
          Why is tracking food important?
        </DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-4 pt-6 text-base font-medium text-primary-contrast">
        <p>
          One key goal for controlling your blood sugar levels through food
          choices is to prevent rapid, high blood sugar spikes.
        </p>
        <p>
          A simple rule of thumb: avoid foods with a high glycemic index
          (refined carbohydrates and sugary items). These foods are digested
          quickly and immediately release their sugar into your bloodstream.
        </p>
        <p>
          Foods that have high fiber content (like whole grains and legumes)
          slow down the glucose release into the bloodstream.
        </p>
        <p>
          Healthy fats and proteins also help slow the flow of glucose and
          stabilize blood sugar levels. Foods that have a low glycemic index
          (like non-starchy vegetables) have a minimal effect on blood sugar
          and can help balance out meals.
        </p>
        <p>
          Everyone&apos;s body responds differently to different foods.
          Tracking your blood sugar after you eat can help you learn more
          about how your body responds.
        </p>
      </div>
    </DialogContent>
  </Dialog>
)

export default FoodLogInfoModal
